// extracted by mini-css-extract-plugin
export default {"label":"CopyModal_label__geiX7"};